// src/App.js
import React from 'react';
import Header from './components/Header';
import About from './components/About';
import WorkExperience from './components/WorkExperience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import DownloadPDF from './components/DownloadPDF';
import { CONTACT } from './constants';
import { LanguageProvider } from './context/LanguageContext';

const App = () => {
  const year = new Date().getFullYear();

  return (
    <LanguageProvider>
      <div className="min-h-screen py-8 md:py-10 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="flex justify-end mb-4 no-print">
            <DownloadPDF />
          </div>

          <main>
            <Header />
            <About />
            <WorkExperience />
            <Skills />
            <Projects />
          </main>

          <footer className="mt-10 pb-6 text-center">
            <p className="mono text-xs uppercase tracking-widest text-zinc-500">
              {CONTACT.name} · {year} · <a className="hover:text-zinc-900" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </p>
          </footer>
        </div>
      </div>
    </LanguageProvider>
  );
};

export default App;
